/**
 * 基础路由定制化配置
 */
/* eslint-disable */
// import { UserLayout, BasicLayout, RouteView } from '@/layouts'
// 在此处导入你的子系统路由
import indexRouter from '@/router/child-system/index'
import {asyncRouterMap} from '@/config/router.config'

/* eslint-enable */

/**
 * 项目路由
 * @type { *[] }
 */
const topNavHash = {
  // 基础管理（原平台运营方）
  operating: {
    name: 'index',
    meta: {
      title: '系统'
    },
    children: indexRouter
  }
}
export { topNavHash }
